import React, { useRef } from 'react';
import FilterCommon, { useFilterCommon } from '@opm/components/FilterCommon';
import MarketContentBody from '@opm/components/MarketContentBody';
import { dealwithHashtag } from '@opm/components/MarketConnect/utils/videoAndHashtag';
import marketConnect from '@opm/components/MarketConnect';
import HashtagTable from '../../HashtagTable';
import type { IHashtagTabProps } from '../types';

const TIKTOK_PRE_REQUEST_ID = 'hotspot/hashtag/list';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function TiktokTab({ defaultFilter, backCondConfig, translateCategory }: IHashtagTabProps & Record<string, any>) {
  const timeRangeIsChange = useRef(false);

  const { filter, setFilter, loading, ...filterProps } = useFilterCommon({
    keys: [
      'SingleDateRange',
      'TimeRange',
      'HashtagCategory',
      'HashtagCountryRegion',
      'HashtagSource',
    ],
    dependencyOrder: [
      'SingleDateRange',
      'TimeRange',
      'HashtagSource',
      'HashtagCategory',
      'HashtagCountryRegion',
    ],
  });

  return (
    <MarketContentBody
      loading={loading}
      filterSlot={
        <FilterCommon
          {...filterProps}
          userDefaultValue={defaultFilter}
          realTimeMode
          finallyDealwithDefaultValue={(value: any) => {
            // HashtagCountryRegion.defaultValue may strip countries when cond
            // options don't match the source key. Restore from API default_country.
            if (
              defaultFilter?.countries?.length
            ) {
              return { ...value, countries: [...defaultFilter.countries] };
            }
            return value;
          }}
          confirm={(value: any) => {
            timeRangeIsChange.current =
              filter?.time_range !== value?.time_range ||
              value?.countries?.length > 1;
            if (value?.source === 'tiktok_gaming') {
              delete value.categories;
            }
            setFilter(value);
          }}
          backCondConfig={backCondConfig}
          hiddenFilters={(key) =>
            key === 'HashtagCategory' && filter?.source === 'tiktok_gaming'
          }
        />
      }
    >
      <HashtagTable
        translateCategory={translateCategory}
        filter={filter}
        timeRangeIsChange={timeRangeIsChange.current}
        instanceId={filterProps.instanceId}
      />
    </MarketContentBody>
  );
}

export default marketConnect<IHashtagTabProps & Record<string, any>>({
  ids: [TIKTOK_PRE_REQUEST_ID],
  dealwith: dealwithHashtag(TIKTOK_PRE_REQUEST_ID),
})(TiktokTab);
